// extracted by mini-css-extract-plugin
export default {"wrapper":"AboutMe_wrapper__iJ6aC","imageContainer":"AboutMe_imageContainer__mup8-","contentContainer":"AboutMe_contentContainer__ie4b+","tabs":"AboutMe_tabs__2tHcm"};